var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStripeLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 18,
    height: 18,
    rx: 3,
    fill: "#635BFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.72216 8.18065C9.72216 7.7951 10.0243 7.64656 10.5251 7.64656C11.3424 7.66451 12.1446 7.88126 12.8682 8.27968V5.95383C12.1229 5.64654 11.328 5.49255 10.527 5.50028C8.60895 5.50028 7.33301 6.54866 7.33301 8.29949C7.33301 11.0294 10.9237 10.5943 10.9237 11.7708C10.9237 12.2256 10.5452 12.3742 10.0167 12.3742C9.23272 12.3742 8.23052 12.0381 7.43708 11.582V13.9362C8.25158 14.3051 9.12922 14.4969 10.0167 14.5C11.982 14.5 13.333 13.4813 13.333 11.7107C13.3223 8.76426 9.72216 9.28845 9.72216 8.18065Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripeLogo);
export default __webpack_public_path__ + "static/media/stripe-logo.91510ed12a0f3f1cc070b1e9cc45605c.svg";
export { ForwardRef as ReactComponent };